import { render, staticRenderFns } from "./SVC00000.vue?vue&type=template&id=90e0b048"
import script from "./SVC00000.vue?vue&type=script&lang=js"
export * from "./SVC00000.vue?vue&type=script&lang=js"
import style0 from "./SVC00000.vue?vue&type=style&index=0&id=90e0b048&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports